"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
var constants = require("../../shared/code/Constants");
var PsqHelper_1 = require("../../shared/code/PsqHelper");
function viewSF() {
    var _this = this;
    var getSelectedValue = function (props) { return (props.question.options.find(function (x) { return x.isChecked; }) || {}).responseId; };
    var getStateByProps = function (props) { return ({
        options: props.question.options.map(function (o) {
            return { "value": o.responseId, "label": o.text, "booleanValue": o.booleanValue };
        }),
        selectedValue: getSelectedValue(props),
        errorMessage: props.errorMessage,
        question: props.question,
        constants: constants,
        formattedQuestion: PsqHelper_1.PsqHelper.getLabel(props.question)
    }); };
    return {
        constructor: function (props) {
            _this.state = getStateByProps(props);
        },
        willReceiveProps: function (nextProps) {
            if (nextProps.question.questionId != _this.props.question.questionId) {
                _this.setState(getStateByProps(nextProps));
            }
            if (nextProps.errorMessage && !_this.state.selectedValue) {
                _this.setState({ errorMessage: nextProps.errorMessage });
            }
        },
        events: {
            onChange: function (value, id) {
                _this.setState({ selectedValue: value, errorMessage: null });
                var booleanValue = _this.state.options.find(function (o) { return o.value === value; }).booleanValue;
                _this.props.onChange(value, _this.props.question.questionId, booleanValue);
            }
        }
    };
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/.tmp/PSQMultiChoiceSingleAnswer/ViewSF.js
// module id = 703
// module chunks = 0